import { useEffect, useState } from "react";
import { scrollToTarget } from "../lib/smooth";

export const Header = () => {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll, { passive: true });
    onScroll();
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      className={`fixed top-0 inset-x-0 z-50 border-b backdrop-blur-md transition-colors duration-500 ${
        scrolled ? "bg-night/95 border-transparent" : "bg-paper/90 border-hairline"
      }`}
      data-testid="site-header"
    >
      <div className="w-full px-5 md:px-8 h-16 md:h-20 flex items-center justify-between">
        <a
          href="#"
          onClick={(e) => {
            e.preventDefault();
            scrollToTarget(0);
          }}
          data-testid="brand-link"
          aria-label="Les Mots pour le Dire — retour en haut de page"
          className="flex items-center"
        >
          <img
            src="/logo.png"
            alt="Les Mots pour le Dire — Écrivain public"
            className={`h-9 sm:h-12 md:h-14 w-auto object-contain transition-all duration-500 ${scrolled ? "invert" : ""}`}
          />
        </a>
        <button
          type="button"
          onClick={() => scrollToTarget("#contact")}
          data-testid="nav-cta-contact-button"
          className={`text-[13px] font-medium px-5 py-2.5 tracking-wide whitespace-nowrap transition-colors duration-500 ${
            scrolled ? "bg-vermilion text-white hover:bg-white hover:text-ink" : "bg-ink text-paper hover:bg-vermilion"
          }`}
        >
          Me contacter
        </button>
      </div>
    </header>
  );
};
